module.exports = __webpack_public_path__ + "img/flynn-logo-primary.63e18673.png";